import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class TextAnimations {
	constructor() {
		this.textContainer = document.querySelectorAll('[data-text-animation]')

		if (!this.textContainer.length) return

		this.#init()
	}

	#init() {
		this.textContainer.forEach(container => this.#loopThroughContainers(container))
	}

	#loopThroughContainers(container) {
		const textItems = container.querySelectorAll(
			':is(h1, h2, h3, h4, h5, h6, .is-h1, .is-h2, .is-h3, .is-h4, .is-h5, .is-supertitle):not(.tease *)'
		)

		if (!textItems.length) return

		const text = SplitText.create(textItems, { type: 'lines, words', mask: 'words' })

		const overlayContainers = []
		text.words.forEach(wordContainer => {
			const overlay = document.createElement('div')
			wordContainer.style.paddingBottom = '0.1em'

			Object.assign(overlay.style, {
				position: 'absolute',
				bottom: 0,
				left: '-1px',
				width: 'calc(100% + 2px)',
				height: '100%',
				backgroundColor: container.dataset.textAnimation ?? '#FC5454',
			})

			wordContainer.append(overlay)

			overlayContainers.push(overlay)
		})
		const tl = gsap.timeline({ scrollTrigger: { trigger: container, start: '' } })

		tl.to(overlayContainers, {
			yPercent: 110,
			stagger: 0.06,
			duration: 0.6,
			ease: 'power2.inOut',
		})
	}
}
